export type ChannelType = "desktop" | "tablet" | "mobile";

/**
 * Which kind of device is this. Used both for channel resolution (which avatar/settings the
 * backend serves) and for capability decisions — streamed-audio support, speech-recognition
 * availability — so it lives here rather than in any one page.
 */
export function detectChannelType(): ChannelType {
  const uaData = (navigator as any).userAgentData;
  const touchPoints = navigator.maxTouchPoints || 0;
  const screenWidth = window.screen.width;
  const coarsePointer = window.matchMedia("(pointer: coarse)").matches;
  const noHover = window.matchMedia("(hover: none)").matches;

  // Client Hints API (most reliable, modern browsers)
  if (uaData?.mobile === true) {
    return touchPoints > 0 && screenWidth >= 768 ? "tablet" : "mobile";
  }
  if (uaData?.mobile === false) return "desktop";

  // Fallback: multi-signal scoring
  const mobileScore = [touchPoints > 0, screenWidth < 768, coarsePointer, noHover].filter(Boolean).length;
  const tabletScore = [touchPoints > 0, screenWidth >= 768 && screenWidth < 1280, coarsePointer].filter(Boolean).length;

  if (mobileScore >= 3) return "mobile";
  if (tabletScore >= 2 && touchPoints > 0) return "tablet";
  return "desktop";
}

/**
 * True for phones AND tablets. Tablets are grouped with phones deliberately: the constraints that
 * make this distinction matter — no reliable Web Speech engine, MSE audio that starves — are
 * properties of mobile browser engines, not of screen size.
 */
export function isMobileDevice(): boolean {
  return detectChannelType() !== "desktop";
}
